export const PROFILE_COVERS = [
  {
    id: 1,
    status: true,
    pathImg: '/img/profile/cover/1.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 2,
    status: false,
    pathImg: '/img/profile/cover/2.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 3,
    status: false,
    pathImg: '/img/profile/cover/3.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 4,
    status: false,
    pathImg: '/img/profile/cover/4.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 5,
    status: false,
    pathImg: '/img/profile/cover/5.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 6,
    status: false,
    pathImg: '/img/profile/cover/6.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 7,
    status: true,
    pathImg: '/img/profile/cover/7.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 8,
    status: false,
    pathImg: '/img/profile/cover/8.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 9,
    status: false,
    pathImg: '/img/profile/cover/9.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 10,
    status: false,
    pathImg: '/img/profile/cover/10.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 11,
    status: false,
    pathImg: '/img/profile/cover/11.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 12,
    status: false,
    pathImg: '/img/profile/cover/12.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 13,
    status: true,
    pathImg: '/img/profile/cover/13.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 14,
    status: false,
    pathImg: '/img/profile/cover/14.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 15,
    status: false,
    pathImg: '/img/profile/cover/15.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 16,
    status: false,
    pathImg: '/img/profile/cover/16.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 17,
    status: false,
    pathImg: '/img/profile/cover/17.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 18,
    status: false,
    pathImg: '/img/profile/cover/18.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 19,
    status: true,
    pathImg: '/img/profile/cover/19.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 20,
    status: false,
    pathImg: '/img/profile/cover/20.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 21,
    status: false,
    pathImg: '/img/profile/cover/21.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 22,
    status: false,
    pathImg: '/img/profile/cover/22.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 23,
    status: false,
    pathImg: '/img/profile/cover/23.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 24,
    status: false,
    pathImg: '/img/profile/cover/24.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 25,
    status: false,
    pathImg: '/img/profile/cover/25.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 26,
    status: false,
    pathImg: '/img/profile/cover/26.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 27,
    status: false,
    pathImg: '/img/profile/cover/27.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 28,
    status: false,
    pathImg: '/img/profile/cover/28.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 29,
    status: false,
    pathImg: '/img/profile/cover/29.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
  {
    id: 30,
    status: false,
    pathImg: '/img/profile/cover/30.png',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
  },
];
export const TEMPLATE11_COVERS = [
  {
    id: 16,
    status: false,
    pathImg: '/img/profile/cover/16.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp11-1',
  },
  {
    id: 19,
    status: false,
    pathImg: '/img/profile/cover/19.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp11-2',
  },
  {
    id: 17,
    status: false,
    pathImg: '/img/profile/cover/17.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp11-3',
  },
];
export const TEMPLATE12_COVERS = [
  {
    id: 27,
    status: false,
    pathImg: '/img/profile/cover/27.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp12-1',
  },
  {
    id: 8,
    status: false,
    pathImg: '/img/profile/cover/8.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp12-2',
  },
  {
    id: 34,
    status: false,
    pathImg: '/img/profile/cover/34.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp12-3',
  },
  {
    id: 4,
    status: false,
    pathImg: '/img/profile/cover/4.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp12-4',
  },

];
export const TEMPLATE13_COVERS = [
  {
    id: 14,
    status: false,
    pathImg: '/img/profile/cover/14.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp13-1',
  },
  {
    id: 24,
    status: false,
    pathImg: '/img/profile/cover/24.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp13-2',
  },
  {
    id: 29,
    status: false,
    pathImg: '/img/profile/cover/29.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp13-3',
  },
  {
    id: 33,
    status: false,
    pathImg: '/img/profile/cover/33.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp13-4',
  },
  {
    id: 25,
    status: false,
    pathImg: '/img/profile/cover/25.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp13-5',
  },
];
export const TEMPLATE14_COVERS = [
  {
    id: 26,
    status: false,
    pathImg: '/img/profile/cover/26.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-1',
  },
  {
    id: 27,
    status: false,
    pathImg: '/img/profile/cover/27.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-2',
  },
  {
    id: 14,
    status: false,
    pathImg: '/img/profile/cover/14.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-3',
  },
  {
    id: 24,
    status: false,
    pathImg: '/img/profile/cover/24.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-4',
  },
  {
    id: 29,
    status: false,
    pathImg: '/img/profile/cover/29.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-5',
  },
  {
    id: 33,
    status: false,
    pathImg: '/img/profile/cover/33.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-6',
  },
  {
    id: 30,
    status: false,
    pathImg: '/img/profile/cover/30.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp14-7',
  },
];
export const TEMPLATE15_COVERS = [
  {
    id: 21,
    status: false,
    pathImg: '/img/profile/cover/21.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp15-1',
  },
  {
    id: 18,
    status: false,
    pathImg: '/img/profile/cover/18.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp15-2',
  },
  {
    id: 23,
    status: false,
    pathImg: '/img/profile/cover/23.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp15-3',
  },
  {
    id: 15,
    status: false,
    pathImg: '/img/profile/cover/15.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp15-4',
  },
  {
    id: 6,
    status: false,
    pathImg: '/img/profile/cover/6.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp15-5',
  },
  {
    id: 20,
    status: false,
    pathImg: '/img/profile/cover/20.jpg',
    pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
    class: 'aprobacion-inactivo',
    templateNumber: 'temp15-6',
  },
];

